import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';
import { FolderPlusIcon } from 'src/assets/icons/FolderPlusIcon';
import { RemoveTrashIcon } from 'src/assets/icons/RemoveTrashIcon';
import Icon from 'src/components/Icon/Icon';

interface UploaderType {
    hideMaxSizeInfo?: boolean;
}

export const Wrapper = styled('div', { label: 'Wrapper' })<UploaderType>`
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    ${({hideMaxSizeInfo}): string => hideMaxSizeInfo === true ? '' : 'padding-top: 28px'};
`;

export const Description = styled('span', { label: 'Description' })`
    font-size: 12px;
    display: block;
    padding: 8px 0;
    line-height: 1;
    user-select: none;
`;

export const Separator = styled('span', { label: 'Separator' })`
    display: block;
    font-size: 14px;
    font-weight: ${fontWeight.bold};
    text-align: center;
    padding: 10px;
`;

export const FileUploadWrapper = styled('div', { label: 'FileUploadWrapper' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 auto;
`;

export const InfoWrapper = styled('div', { label: 'InfoWrapper' })`
    display: flex;
`;

export const IconStyled = styled(Icon, { label: 'IconStyled' })`
    font-size: 12px;
    line-height: 1;
    margin-right: 8px;
    background-color: ${mainColors.status.success};
    color: ${mainColors.default.light};
    min-width: 24px;
    min-height: 24px;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
`;

export const Info = styled('div', { label: 'Info' })`
    display: flex;
    flex-direction: column;
`;

export const FileName = styled('span', { label: 'FileName' })`
    font-size: 14px;
    line-height: 1;
    margin-bottom: 4px;
`;

export const Status = styled('span', { label: 'Status' })`
    font-size: 12px;
    line-height: 1;
    color: ${mainColors.grays.gray400};
`;

export const TrashIconWrapper = styled(RemoveTrashIcon, { label: 'TrashIconWrapper' })`
    cursor: pointer;
    margin-left: 8px;
    align-self: center;
`;

export const FolderPlusIconWrapper = styled(FolderPlusIcon, { label: 'FolderPlusIconWrapper' })`
    margin-right: 8px;
`;
